export type CookieConsent = Omit<
  NonNullable<typeof window.Cookiebot>["consent"],
  "stamp"
> & {
  isDisabled?: boolean;
};

export const COOKIE_CONSENT_VALUES = [
  "necessary",
  "preferences",
  "statistics",
  "marketing",
] as const;

export type CookieConsentList =
  | (typeof COOKIE_CONSENT_VALUES)[number][]
  | ["disabled"];

export const COOKIE_CONSENT_DEFAULTS: CookieConsent = {
  necessary: true,
  preferences: true,
  statistics: true,
  marketing: true,
  isDisabled: true,
};
